// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as UseEnv$Showside from "../hook/UseEnv.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as Previous$Showside from "../utils/Previous.bs.js";
import * as BasicTypes$Showside from "../types/BasicTypes.bs.js";
import * as Breakpoint2$Showside from "../utils/Breakpoint2.bs.js";
import * as Configuration$Showside from "../types/Configuration.bs.js";
import * as QuickViewCard$Showside from "./QuickViewCard.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as CategoryContent$Showside from "./CategoryContent.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as LegacyShowside_Category$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_Category.bs.js";
function getSlidesPerView(isMobile, layout) {
  var match = layout.size;
  var match$1 = layout.shape;
  switch (match) {
    case /* Small */0:
      if (match$1 === 1) {
        if (isMobile) {
          return 5.2;
        } else {
          return 8.2;
        }
      } else if (isMobile) {
        return 5.2;
      } else {
        return 12.2;
      }
    case /* Medium */1:
      if (match$1 === 1) {
        if (isMobile) {
          return 4.2;
        } else {
          return 7.2;
        }
      } else if (isMobile) {
        return 4.8;
      } else {
        return 9.2;
      }
    case /* Large */2:
      if (match$1 === 1) {
        if (isMobile) {
          return 3.2;
        } else {
          return 6.2;
        }
      } else if (isMobile) {
        return 4.2;
      } else {
        return 8.2;
      }
  }
}
function getBasicShape(shape) {
  if (typeof shape === "number") {
    switch (shape) {
      case /* Tall */0:
        return /* Tall */6;
      case /* Square */1:
        return /* Square */1;
      case /* Circle */2:
        return /* Circle */0;
    }
  } else {
    var match = shape._0;
    return /* Custom */{
      _0: match.width,
      _1: match.height
    };
  }
}
function makeApiUrl(apiHostname, live, backup, configId, storeId, hideOutOfStock, breakpoint, offset, offsetByNodeId, source) {
  var endpoint;
  endpoint = typeof source === "number" ? undefined : source.TAG === /* ByProductIds */0 ? "/api/get_related_media_by_products?product_ids=" + source._0.join(",") : "/api/get_related_media_by_category?category_id=" + source._0 + Belt_Option.mapWithDefault(storeId, "", function (storeId) {
    return "&store_id=" + storeId;
  }) + (hideOutOfStock ? "&in_stock=true" : "");
  return Belt_Option.map(endpoint, function (endpoint) {
    return apiHostname + endpoint + ("&config_id=" + configId) + (live ? "&live=true" : "") + Belt_Option.mapWithDefault(backup, "", function (backup) {
      return "&backup=" + backup;
    }) + "&showside_format=true&breakpoint=" + breakpoint + ("&limit=" + String(Configuration$Showside.nodeLimit)) + (offsetByNodeId !== undefined ? "&offset_by_node_id=" + offsetByNodeId : "&offset=" + String(offset)) + "&global=true";
  });
}
function useRelatedMedia(count, shapeOpt, at, enabledOpt, source) {
  var shape = shapeOpt !== undefined ? shapeOpt : /* Square */1;
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var match = ViewportContext$Showside.use(undefined);
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var previewMode = match$1.previewMode;
  var match$2 = UseEnv$Showside.use(undefined);
  var match$3 = ConfigurationProvider$Showside.use(undefined);
  var match$4 = match$3.config;
  var transitiveAccount = match$4.transitiveAccount;
  var isEnabledInPLP = Belt_Option.mapWithDefault(transitiveAccount, false, function (account) {
    return account.plpShowRelatedMedia;
  }) && enabled;
  var isEnabledInPDP = Belt_Option.mapWithDefault(transitiveAccount, false, function (account) {
    return account.pdpShowRelatedMedia;
  }) && enabled;
  var source$1 = at !== 1 ? at !== 0 || isEnabledInPDP ? source : /* NoSource */0 : isEnabledInPLP ? source : /* NoSource */0;
  var live = previewMode !== undefined ? typeof previewMode === "number" ? previewMode !== 0 : false : true;
  var backup = previewMode !== undefined && typeof previewMode !== "number" ? previewMode._0.toString() : undefined;
  var apiUrl = makeApiUrl(match$2.smartnavApiHost, live, backup, match$4.id, match$4.transitiveStoreId, match$4.settings.hideOutOfStock, Breakpoint2$Showside.toString(match.breakpoint), 0, undefined, source$1);
  var apiUrl$1 = Previous$Showside.usePreviousSome(apiUrl);
  var match$5 = UseApi$Showside.useCategories(apiUrl$1);
  var rawData = match$5.data;
  var placeholders = React.useMemo(function () {
    if (typeof source$1 === "number" || count === undefined) {
      return;
    } else {
      return {
        categories: Belt_Array.makeBy(Math.min(count, Configuration$Showside.nodeLimit), function (index) {
          var id = "related-media-placeholder-" + String(index);
          var card = {
            TAG: /* MedialessCard */4,
            _0: {
              link: undefined,
              size: /* Md */4,
              shape: getBasicShape(shape)
            }
          };
          var categoryType = {
            TAG: /* QuickView */2,
            _0: {
              isStories: false,
              isPinned: false,
              firstCard: undefined,
              externalConnection: undefined,
              children: [],
              loadMoreChildren: undefined,
              totalChildren: count,
              link: undefined,
              products: [],
              imageHotspots: undefined,
              imageWidth: undefined,
              imageHeight: undefined
            }
          };
          var newrecord = Caml_obj.obj_dup(LegacyShowside_Category$ApiTypes.empty);
          newrecord.categoryType = categoryType;
          newrecord.card = card;
          newrecord.showDescription = false;
          newrecord.showTitle = false;
          newrecord.id = id;
          return newrecord;
        }),
        previous: undefined,
        next: undefined,
        offset: 0,
        total: count
      };
    }
  }, [count]);
  var data = Belt_Option.orElse(rawData, placeholders);
  return React.useMemo(function () {
    try {
      if (data === undefined) {
        return;
      }
      if (!(data.categories.length !== 0 && enabled)) {
        return;
      }
      var newrecord = Caml_obj.obj_dup(LegacyShowside_Category$ApiTypes.empty);
      return newrecord.categoryType = {
        TAG: /* QuickView */2,
        _0: {
          isStories: false,
          isPinned: false,
          firstCard: undefined,
          externalConnection: undefined,
          children: data.categories,
          loadMoreChildren: data.next,
          totalChildren: data.total,
          link: undefined,
          products: [],
          imageHotspots: undefined,
          imageWidth: undefined,
          imageHeight: undefined
        }
      }, newrecord.card = {
        TAG: /* MedialessCard */4,
        _0: {
          link: undefined,
          size: /* Md */4,
          shape: getBasicShape(shape)
        }
      }, newrecord.title = "Related Media", newrecord.id = "related-media", newrecord;
    } catch (exn) {
      return;
    }
  }, [apiUrl$1, rawData, enabled]);
}
function useCallbacks(source) {
  var match = RouterProvider$Showside.useRouter(undefined);
  var goTo = match.goTo;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var onQuickViewClick = React.useCallback(function (parentCategory) {
    return function (category) {
      var tmp;
      tmp = typeof source === "number" || source.TAG !== /* ByProductIds */0 ? undefined : source._0;
      var tmp$1;
      tmp$1 = typeof source === "number" || source.TAG === /* ByProductIds */0 ? undefined : source._0;
      return Curry._3(goTo, undefined, undefined, {
        TAG: /* QuickView */3,
        _0: {
          mediaId: category.id,
          mediaParentId: "related-media",
          albumId: undefined,
          productId: undefined,
          relatedMediaProductIds: tmp,
          relatedMediaCategoryId: tmp$1,
          variantId: undefined,
          panelClosed: undefined,
          zoomedPhotoIndex: undefined,
          time: undefined
        }
      });
    };
  }, [goTo]);
  var onOverlayProductClick = React.useCallback(function (category) {
    return function (parentCategory, product, variant) {
      var tmp;
      tmp = typeof source === "number" || source.TAG !== /* ByProductIds */0 ? undefined : source._0;
      var tmp$1;
      tmp$1 = typeof source === "number" || source.TAG === /* ByProductIds */0 ? undefined : source._0;
      return Curry._3(goTo, undefined, undefined, {
        TAG: /* QuickView */3,
        _0: {
          mediaId: category.id,
          mediaParentId: "related-media",
          albumId: undefined,
          productId: product.id,
          relatedMediaProductIds: tmp,
          relatedMediaCategoryId: tmp$1,
          variantId: Belt_Option.map(variant, function (variant) {
            return variant.id;
          }),
          panelClosed: undefined,
          zoomedPhotoIndex: undefined,
          time: undefined
        }
      });
    };
  }, [goTo]);
  return {
    onCategoryClick: match$1.onCategoryClick,
    onQuickViewClick: onQuickViewClick,
    onProductClick: match$1.onProductClick,
    onOverlayProductClick: onOverlayProductClick
  };
}
function useSlider(count, at, scrollableContainerRef, source, shape, size, className, param) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var account = match$1.transitiveAccount;
  var layoutSettings = React.useMemo(function () {
    if (account !== undefined) {
      var layout = account.pdpRelatedMediaStyle;
      var exit = 0;
      if (layout !== undefined) {
        if (at === /* PDP */0) {
          return layout;
        }
        exit = 2;
      } else {
        exit = 2;
      }
      if (exit === 2) {
        var match = account.plpRelatedMediaStyle;
        if (match !== undefined && match.TAG === /* SliderLayout */0 && at === /* PLP */1) {
          return match._0;
        }
      }
    }
    return {
      shape: Belt_Option.getWithDefault(shape, /* Square */1),
      size: Belt_Option.getWithDefault(size, /* Medium */1)
    };
  }, [account]);
  var category = useRelatedMedia(count, layoutSettings.shape, at, undefined, source);
  var match$2 = useCallbacks(source);
  var match$3 = ViewportContext$Showside.use(undefined);
  var isNarrowContainer = match$3.isMobile || match$1.settings.desktopPDPLayout === /* Old */0 && at === /* PDP */0;
  var layout = React.useMemo(function () {
    return {
      TAG: /* SliderLayout */0,
      _0: {
        slidesPerView: getSlidesPerView(isNarrowContainer, layoutSettings),
        gap: BasicTypes$Showside.emptySliderPayload.gap,
        maxWidth: BasicTypes$Showside.emptySliderPayload.maxWidth,
        padding: at === /* PDP */0 ? 0 : undefined,
        rows: BasicTypes$Showside.emptySliderPayload.rows,
        effect: BasicTypes$Showside.emptySliderPayload.effect,
        nav: BasicTypes$Showside.emptySliderPayload.nav,
        transition: BasicTypes$Showside.emptySliderPayload.transition,
        transitionSpeed: BasicTypes$Showside.emptySliderPayload.transitionSpeed,
        autoplay: BasicTypes$Showside.emptySliderPayload.autoplay,
        autoplayDelay: BasicTypes$Showside.emptySliderPayload.autoplayDelay,
        loop: BasicTypes$Showside.emptySliderPayload.loop
      }
    };
  }, [layoutSettings]);
  if (category === undefined) {
    return;
  }
  var tmp = {
    category: category,
    scrollableContainerRef: scrollableContainerRef,
    layout: layout,
    index: 0,
    forcedHideTitle: true,
    forcedHideDescription: true,
    onOverlayProductClick: match$2.onOverlayProductClick,
    onCategoryClick: match$2.onCategoryClick,
    onQuickViewClick: match$2.onQuickViewClick,
    onProductClick: match$2.onProductClick
  };
  if (className !== undefined) {
    tmp.className = className;
  }
  return Caml_option.some(React.createElement(CategoryContent$Showside.make, tmp));
}
function RelatedMediaContent$Slider(Props) {
  var count = Props.count;
  var at = Props.at;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var source = Props.source;
  var shape = Props.shape;
  var size = Props.size;
  var className = Props.className;
  return Belt_Option.getWithDefault(useSlider(count, at, scrollableContainerRef, source, shape, size, className, undefined), null);
}
RelatedMediaContent$Slider.displayName = "RelatedMediaContent.Slider";
var Slider = {
  make: RelatedMediaContent$Slider
};
function useInlineRelatedMedia(count, at, parentCategory, enabled, source) {
  RouterProvider$Showside.useRouter(undefined);
  var match = useCallbacks(source);
  var onOverlayProductClick = match.onOverlayProductClick;
  var onQuickViewClick = match.onQuickViewClick;
  var cardShape = Category$Showside.CategoryCard.getCardShape(undefined, undefined, parentCategory.card);
  return Belt_Option.map(Belt_Option.map(useRelatedMedia(count, undefined, at, enabled, source), Category$Showside.getChildren), function (categories) {
    return Belt_Array.map(categories, function (category, fluid, shape) {
      return React.createElement(QuickViewCard$Showside.make, {
        category: category,
        parentCategory: parentCategory,
        shape: Belt_Option.getWithDefault(shape, cardShape),
        fluid: fluid,
        showTitle: false,
        enableViewProductButton: true,
        onClick: onQuickViewClick,
        onOverlayProductClick: onOverlayProductClick,
        key: parentCategory.id + category.id
      });
    });
  });
}
var Inline = {
  useInlineRelatedMedia: useInlineRelatedMedia
};
var nodeLimit = Configuration$Showside.nodeLimit;
export { getSlidesPerView, getBasicShape, nodeLimit, makeApiUrl, useRelatedMedia, useCallbacks, useSlider, Slider, Inline };
/* react Not a pure module */